<script setup>
// Банер «встановіть як додаток» на головній; коли показувати — usePwaInstall
const { mode, install, dismiss } = usePwaInstall()

const hint = {
  ios: 'Натисніть «Поділитися» внизу й оберіть «На початковий екран»',
  'mac-safari': 'У меню «Файл» оберіть «Додати в Dock»',
  'firefox-android': 'Відкрийте меню ⋮ і оберіть «Встановити»',
}
</script>

<template>
  <Transition name="install">
    <div v-if="mode" class="mx-auto px-[10px] pt-[10px] w-full max-w-[1350px]">
      <div
        class="flex items-center gap-[12px] bg-neutral shadow-lg px-[12px] py-[10px] border border-primary/30 rounded-xl"
      >
        <img
          src="/icons/android-chrome-192x192.png"
          alt=""
          class="rounded-lg w-[40px] h-[40px] shrink-0"
        >
        <div class="flex-1 min-w-0">
          <p class="font-semibold text-neutral-content text-sm">
            Встановіть сайт як додаток
          </p>
          <p class="text-neutral-content/75 text-xs">
            <template v-if="mode === 'prompt'">
              Окремий значок, відкривається на весь екран — без вкладок браузера
            </template>
            <template v-else>{{ hint[mode] }}</template>
          </p>
        </div>
        <button
          v-if="mode === 'prompt'"
          class="shrink-0 btn btn-primary btn-sm"
          @click="install"
        >
          Встановити
        </button>
        <button
          class="flex justify-center items-center rounded-md w-[28px] h-[28px] text-neutral-content/50 hover:text-neutral-content transition-colors shrink-0"
          aria-label="Закрити"
          @click="dismiss"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.install-enter-active,
.install-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.install-enter-from,
.install-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
